import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AgmCoreModule } from '@agm/core';
import { AgmMarkerClustererModule } from '@agm/markerclusterer';

import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from 'environments/environment';
import { HomeComponent } from './components/home/home.component';
import { ListComponent } from './components/home/list/list.component';
import { MapComponent } from './components/home/map/map.component';
import { RouterModule } from '@angular/router';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { DetailsComponent } from './components/home/details/details.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule } from '@angular/material/sort';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ListComponent,
    MapComponent,
    DetailsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    HttpClientModule,
    MatTableModule,
    MatIconModule,
    MatToolbarModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatSortModule,
    MatGridListModule,
    RouterModule.forRoot([
      { path: 'list', component: ListComponent },
      { path: 'details/:id', component: DetailsComponent },
      { path: '', component: MapComponent },
      { path: 'map', component: MapComponent },
      { path: 'home', component: MapComponent },
    ]),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAoN3veC8tZogz6_aHBrgssA_bV6FS_SSE',
    }),
    AgmMarkerClustererModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
